/* CCC Relaunch 2027 – Vorbestellung pro Variante.
   Liest die Variantendaten aus #ccc27-preorder und passt Knopf, Hinweis und Warenkorb-Eigenschaft an. */
(function () {
  if (window.cccPreorderReady) return;
  window.cccPreorderReady = true;

  var T = window.ccc27T || {};
  function tr(k, d, v) {
    var s = T[k] || d;
    if (v) Object.keys(v).forEach(function (x) { s = s.split('{' + x + '}').join(v[x]); });
    return s;
  }
  var LABEL = tr('preorder_btn', 'Vorbestellen');
  var map = {};

  function load() {
    var el = document.getElementById('ccc27-preorder');
    if (!el) return false;
    try { map = JSON.parse(el.textContent) || {}; } catch (e) { return false; }
    return true;
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function forms() {
    return [].slice.call(document.querySelectorAll('form[action*="/cart/add"]')).filter(function (f) {
      var i = f.querySelector('input[name="id"]');
      return i && Object.prototype.hasOwnProperty.call(map, i.value);
    });
  }

  function apply(f) {
    var input = f.querySelector('input[name="id"]');
    var d = map[input.value] || { pre: false };
    var btn = f.querySelector('[name="add"]');
    var span = btn ? btn.querySelector('span') || btn : null;
    var host = f.closest('block-buy-buttons') || f.parentNode;
    var note = f.querySelector('.ccc27-pre-note');
    var prop = f.querySelector('input.ccc27-pre-prop');

    if (d.pre) {
      var when = d.ab ? tr('avail_from', 'lieferbar ab {d}', { d: d.ab }) : tr('when_arrives', 'wir liefern, sobald die Ware bei uns ist');
      if (!note) {
        note = document.createElement('p');
        note.className = 'ccc27-pre-note';
        note.setAttribute('aria-live', 'polite');
        if (btn && btn.parentNode) btn.parentNode.insertBefore(note, btn);
        else f.appendChild(note);
      }
      note.innerHTML = '<b>' + esc(tr('preorder', 'Vorbestellung')) + '</b> · ' + esc(when);
      if (!prop) {
        prop = document.createElement('input');
        prop.type = 'hidden';
        prop.className = 'ccc27-pre-prop';
        f.appendChild(prop);
      }
      /* Eigenschaft im Warenkorb und in der Bestellung, in der Sprache der Kundschaft */
      prop.name = 'properties[' + tr('preorder', 'Vorbestellung') + ']';
      prop.value = when;
      if (span && !btn.disabled && span.textContent.trim() !== LABEL) {
        btn.setAttribute('data-ccc-orig', span.textContent.trim());
        span.textContent = LABEL;
      }
      host.classList.add('ccc27-is-pre');
    } else {
      if (note) note.remove();
      if (prop) prop.remove();
      if (span && span.textContent.trim() === LABEL && btn.getAttribute('data-ccc-orig')) {
        span.textContent = btn.getAttribute('data-ccc-orig');
      }
      host.classList.remove('ccc27-is-pre');
    }
  }

  function all() { forms().forEach(apply); }

  function watch() {
    forms().forEach(function (f) {
      if (f.getAttribute('data-ccc-watch')) return;
      f.setAttribute('data-ccc-watch', '1');
      var input = f.querySelector('input[name="id"]');
      input.addEventListener('change', function () { setTimeout(function () { apply(f); }, 0); });
      var btn = f.querySelector('[name="add"]');
      if (btn && window.MutationObserver) {
        new MutationObserver(function () { apply(f); }).observe(btn, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
      }
    });
  }

  function start() {
    if (!load()) return;
    all();
    watch();
  }

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
  window.addEventListener('pageshow', start);
  document.addEventListener('shopify:section:load', start);
})();
